import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.FacePainting;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "FacePainting.Phaser.IntroductionScene.1",
            "FacePainting.Phaser.IntroductionScene.2",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/FacePainting/scenes/GameIntro.ts